// declares My work action types.

import TopMenuConst from '../constants/top_menu.constants';

export const updateActiveMenu = menuName => ({
  type: TopMenuConst.TOPMENU_UPDATE_ACTIVE,
  menuName,
});

export const updateFavorites = (key, values, pinAction) => ({
  type: TopMenuConst.TOPMENU_UPDATE_FAVORITES,
  pinAction,
  key,
  values,
});

export const updateTopMenuRecentItems = (key, objectId, objectType, objectName, actionType) => ({
  type: TopMenuConst.TOPMENU_UPDATE_RECENT_ITEMS,
  key,
  objectId,
  objectType,
  objectName,
  actionType
});

export const updateTopMenuObjectName = (key, objectId, objectType, objectName) => ({
  type: TopMenuConst.TOPMENU_UPDATE_OBJECT_NAME,
  key,
  objectId,
  objectType,
  objectName,
});

export const updateTopMenuBottomMenuButton = (key, objectType, showMenu) => ({
  type: TopMenuConst.TOPMENU_UPDATE_BOTTOM_MENU_BUTTON,
  key,
  objectType,
  showMenu
});

export const topmenuDeleteObject = (key, objectId, objectType) => ({
  type: TopMenuConst.TOPMENU_DELETE_OBJECT,
  key,
  objectId,
  objectType,
});

export const dumbTheTopMenu = (key, values) => ({
  type: TopMenuConst.DUMBTHETOPMENU,
  key,
  values,
});

export const updateMenuItemPageTitle = (key, title) => ({
  type: TopMenuConst.TOPMENU_SET_PAGE_TITLE,
  key,
  title
});

export const loadTopMenuItems = (items) => ({
  type: TopMenuConst.TOPMENU_LOAD_MENU_ITEMS,
  items
})
